'use client'

/* eslint-disable arrow-body-style */
import React, { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import ADNewLogo from '@components/Ackodrive/header/common/ADNewLogo'

import SearchIcon from '@public/images/icons/searchicon.svg'
import { useWidgetContext } from '@context/userWidgetProps'
import { HEADER_MENU, HEADER_SUBMENU } from './constants/HeaderMenuoptions'
import { MenuLogoHeaderWrapper, HeaderWrapper, SearchIconWrapper } from './styles'
import { type ISubmenu } from './common/menuHeader/submenuDropdown'

import Search from './common/search'
import SearchModal from './common/search/search-modal'

const MenuHeader = dynamic(() => import('@components/Ackodrive/header/common/menuHeader'))
const HamBurgerMenu = dynamic(() => import('@components/Ackodrive/header/common/hamBurgerMenu'))

export interface IMenuItem {
  title: string
  url: string | null
  isActive?: boolean
  submenu?: ISubmenu[]
  icon?: React.ReactNode
  backgroundcolor?: string
  eventName?: string
  collectioName?: string
}

export interface IMenuProps {
  menuItems?: IMenuItem[]
  menuItemsGap: string
  menuFontSize: string
  menuFontWeight: string
  menuLineHeight: string
}

interface INewHeaderProps {
  activeHeaderLink?: string
  hideHeaderMenu?: boolean
  hideHamburgerMenu?: boolean
  hideHeaderLogo?: boolean
  isMobileDevice: boolean
  hideShadow?: boolean
}

const AckoDriveHeader = ({
  isMobileDevice,
  activeHeaderLink,
  hideHeaderMenu,
  hideHeaderLogo,
  hideHamburgerMenu,
  hideShadow,
}: INewHeaderProps) => {
  const [scrollShadow, setScrollShadow] = useState<boolean>(false)
  const [showSearchIcon, setShowSearchIcon] = useState(true)
  const [showSearchModal, setShowSearchModal] = useState(false)

  const searchIcon = (alignRight = false) => {
    return (
      isMobileDevice && (
        <SearchIconWrapper
          alignRight={alignRight}
          data-testid="searchicon"
          onClick={() => {
            setShowSearchIcon(true)
            setShowSearchModal(true)
          }}>
          <SearchIcon />
        </SearchIconWrapper>
      )
    )
  }

  const search = ({ width }) => <Search isMobile={isMobileDevice} width={width} />
  const desktopSearch = () => !isMobileDevice && search({ width: '18.125rem' })
  const mobileSearch = () => isMobileDevice && !showSearchIcon && search({ width: '100%' })

  const searchModal = () =>
    isMobileDevice && <SearchModal showModal={showSearchModal} onBackAction={() => setShowSearchModal(false)} />

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0 && !hideShadow) {
        setScrollShadow(true)
      } else {
        setScrollShadow(false)
      }
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const { widgetModal } = useWidgetContext()

  return (
    <HeaderWrapper widgetModal={widgetModal} id="headerComponent" isMobile={isMobileDevice} scrollShadow={scrollShadow}>
      <MenuLogoHeaderWrapper isMobile={isMobileDevice}>
        {!hideHamburgerMenu && <HamBurgerMenu />}
        {!hideHeaderLogo && <ADNewLogo isMobile={isMobileDevice} />}
        {!hideHeaderMenu && (
          <MenuHeader
            menuItems={[
              {
                title: HEADER_MENU.HOME,
                url: '/',
                isActive: activeHeaderLink === HEADER_MENU.HOME,
                eventName: 'tap_btn_home',
              },
              {
                title: HEADER_MENU.BUY_NEW_CAR,
                url: '/cars/',
                isActive: activeHeaderLink === HEADER_MENU.BUY_NEW_CAR,
                submenu: HEADER_SUBMENU.BUY_NEW_CAR,
              },
              {
                title: HEADER_MENU.BLOG,
                url: '/articles/',
                isActive: activeHeaderLink === HEADER_MENU.BLOG,
                submenu: HEADER_SUBMENU.BLOG,
              },
            ]}
            menuItemsGap="2.4375rem"
            menuFontSize="1.125rem"
            menuFontWeight="600"
            menuLineHeight="1.5rem"
          />
        )}
      </MenuLogoHeaderWrapper>
      <div>
        {desktopSearch()}
        {mobileSearch()}
        {searchIcon(true)}
      </div>
      {showSearchModal && searchModal()}
    </HeaderWrapper>
  )
}

export default AckoDriveHeader
